import React, { useEffect } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { Col, Row } from "reactstrap";
import { withTranslation } from "react-i18next";

import InputFieldText from "Components/Common/InputFieldText";
import SelectField from "Components/Common/SelectField";
import { Checkbox, FormControlLabel, InputAdornment } from "@mui/material";
import DateField from "Components/Common/DatePicker";

import {
  energySettlementOptions,
  solarTypeOptions,
  solarUsagePurposeOptions,
  openAccessPowerOptions,
  solarVolatgeUnit,
} from "common/enums";
import { onlyNumberKeys } from "utils";

const yesterday = moment().add(1, "days");
const SolarDetails = ({ formik, t }) => {
  const {
    setFieldValue,
    values: { solar },
  } = formik;

  useEffect(() => {
    setFieldValue("solar.capacityUnit", solarVolatgeUnit[0].value);
  }, []);

  return (
    <>
      <Row>
        <Col md={4} sm={6}>
          <InputFieldText
            label={t("Name of the Developer of the Solar project") + "*"}
            name="solar.developerName"
            formik={formik}
            placeholder="Enter Name of the Developer of the Solar project"
          />
        </Col>
        <Col md={4} sm={6}>
          <InputFieldText
            label={t("Registration no. of GEDA") + "*"}
            name="solar.gEDANumber"
            formik={formik}
            placeholder="Enter Registration no. of GEDA"
          />
        </Col>
        <Col md={4} sm={6}>
          <InputFieldText
            label={t("Approval No. of Chief Electrical Inspector (CEI)") + "*"}
            name="solar.cEIApprovalNumber"
            formik={formik}
            placeholder="Enter Approval No. of CEI"
          />
        </Col>

        <Col md={4} sm={6}>
          <InputFieldText
            label={t("Capacity of Solar Project") + "*"}
            name="solar.capacity"
            formik={formik}
            type="number"
            InputProps={{
              endAdornment: <InputAdornment position="end">kW</InputAdornment>,
              inputProps: { min: 0, onKeyDown: onlyNumberKeys },
            }}
            placeholder="Enter Capacity of Solar Project"
          />
        </Col>

        <Col md={4} sm={6}>
          <DateField
            label={t("Proposed date of commissioning") + "*"}
            name="solar.proposedDate"
            formik={formik}
            format="DD-MM-YYYY"
            minDate={yesterday}
            placeholder="Select Proposed date of commissioning"
            disablePast
          />
        </Col>
        <Col md={4} sm={6}>
          <SelectField
            label={t("Type of Solar Power Project") + "*"}
            name="solar.type"
            formik={formik}
            options={solarTypeOptions || []}
          />
        </Col>
        <Col md={4} sm={6}>
          <SelectField
            label={t("End use of solar generated electricity") + "*"}
            name="solar.endUse"
            formik={formik}
            options={solarUsagePurposeOptions || []}
          />
        </Col>

        <Col md={4} sm={6}>
          <SelectField
            label={t("Energy Settlement option") + "*"}
            name="solar.energySettlement"
            formik={formik}
            options={energySettlementOptions || []}
          />
        </Col>
        <Col md={4} sm={6}>
          <InputFieldText
            label={t(
              "Details of existing capacity of solar project in the premises"
            )}
            name="solar.existingSolarCapacity"
            formik={formik}
            placeholder="Enter Details"
          />
        </Col>
        <Col md={4} sm={6}>
          <InputFieldText
            label={t(
              "Details of existing capacity of any other power generating source in the premises"
            )}
            name="solar.otherPowerCapacity"
            formik={formik}
            placeholder="Enter Details"
          />
        </Col>
        <Col md={4} sm={6}>
          <SelectField
            label={t("Details of power availing through Open Access") + "*"}
            name="solar.openAccess"
            formik={formik}
            options={openAccessPowerOptions || []}
          />
        </Col>
        <Col md={4} sm={6}>
          <InputFieldText
            label={t("Address of proposed project location") + "*"}
            name="solar.proposedProjectLocation"
            formik={formik}
            placeholder="Enter Address of proposed project location"
          />
        </Col>
      </Row>
      <Row>
        <Col md={6} sm={6}>
          <FormControlLabel
            control={
              <Checkbox
                size="small"
                checked={solar.isRegisteredREC}
                onChange={() =>
                  setFieldValue("solar.isRegisteredREC", !solar.isRegisteredREC)
                }
              />
            }
            label={t("Project registered under REC mechanism?")}
          />
        </Col>
      </Row>
    </>
  );
};
SolarDetails.propTypes = {
  formik: PropTypes.object,
  t: PropTypes.func,
};
export default withTranslation()(SolarDetails);
